import "animate.css";
import { ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "Header",
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();
    var showList = ref(false); //是否显示pc端关于血缘之家的下拉列表

    var showMobileList = ref(false); //移动端导航

    var showCompile = ref(false); //移动端导航中 公司简介 导航是否高亮

    var showCore = ref(false); //移动端导航中 核心价值观 导航是否高亮

    var showHistory = ref(false); //移动端导航中 发展历程 导航是否高亮

    var showAbout = computed(function () {
      if (route.path == "/history") {
        return true;
      } else {
        return false;
      }
    }); //当前路径为发展历程时，about导航是否高亮
    //事件
    //鼠标移入展示下拉列表

    function enterList() {
      showList.value = true;
    } //鼠标移出收起下拉列表


    function leaveList() {
      showList.value = false;
    } //点击按钮切换导航显示状态


    function changeMobileList() {
      showMobileList.value = !showMobileList.value;
    } //点击移动端导航跳转路由并隐藏导航


    function navRouterJump(title) {
      //判断是否点击了对应的导航
      if (title == "compile" || title == "core") {
        goAbout(title); //调用跳转指定位置的函数
      }

      if (title == "compile") {
        //当点击 移动端的 公司简介 导航时
        showCompile.value = true; //移动端导航中 公司简介 导航高亮

        showCore.value = false; //重置移动端导航中 核心价值观 导航显示状态

        showHistory.value = false; //重置移动端导航中 发展历程 导航显示状态
      } else if (title == "core") {
        //当点击 移动端的 核心价值观 导航时
        showCore.value = true; //移动端导航中 核心价值观 导航高亮

        showCompile.value = false; //重置移动端导航中 公司简介 导航显示状态

        showHistory.value = false; //重置移动端导航中 发展历程 导航显示状态
      } else if (title == "history") {
        //当点击 移动端的 核心价值观 导航时
        showHistory.value = true; //移动端导航中 发展历程 导航高亮

        showCompile.value = false; //重置移动端导航中 公司简介 导航显示状态

        showCore.value = false; //重置移动端导航中 核心价值观 导航显示状态
      } else {
        showCompile.value = false; //重置移动端导航中 公司简介 导航显示状态

        showCore.value = false; //重置移动端导航中 核心价值观 导航显示状态

        showHistory.value = false; //重置移动端导航中 发展历程 导航显示状态
      }

      showMobileList.value = false; //收起导航
    } //跳转到指定页面页面/并滚动到指定位置


    function goAbout(title) {
      //跳转到about页面
      router.push({
        path: "/about"
      }); //将该函数包裹一个定时器确保可以获取跳转页面后的指定位置的id

      setTimeout(function () {
        if (title == "compile") {
          var goContent = document.getElementById("compileContent");
        } else if (title == "core") {
          var goContent = document.getElementById("coreContent");
        }

        goContent.scrollIntoView({
          behavior: "smooth",
          //平滑滚动
          block: "center" //将指定位置滚动到页面中间

        });
      }, 100);
    } //跳转发展历程页面


    function goHistory() {
      router.push({
        path: "/history"
      });
    }

    return {
      showList: showList,
      showMobileList: showMobileList,
      showCompile: showCompile,
      showCore: showCore,
      showHistory: showHistory,
      showAbout: showAbout,
      enterList: enterList,
      leaveList: leaveList,
      changeMobileList: changeMobileList,
      navRouterJump: navRouterJump,
      goAbout: goAbout,
      goHistory: goHistory
    };
  }
};